/**
 * User preferences. Intended to be used to override non-application-specific defaults set by Cloudpack.
 */
export interface UserPreferences {
  /**
   * The folder where the cloudpack cache will be stored.
   * If unset, the default cache folder at `os.homedir()/.cloudpack` will be used.
   */
  cachePath?: string;
}
